import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    TableRestoreConfig,
    withModeCodec,
} from "@impero-com/ui/domain";
import * as Sentry from "@sentry/react";

export const CONTROL_ENTITIES_TABLE_STATE_STORAGE_KEY = "controlEntitiesList";

export const CONTROL_ENTITIES_LIST_COLUMN_IDS = {
    NAME: "name",
    DESCRIPTION: "description",
    TAGS: "tags",
    CONTROL_ACCESS_RIGHTS: "controlAccessRights",
    RISK_ACCESS_RIGHTS: "riskAccessRights",
} as const;

export const controlEntitiesListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: CONTROL_ENTITIES_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const controlEntitiesListColumnFiltersCodecMap = {
    [CONTROL_ENTITIES_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
    [CONTROL_ENTITIES_LIST_COLUMN_IDS.CONTROL_ACCESS_RIGHTS]:
        withModeCodec(encodedArrayCodec),
    [CONTROL_ENTITIES_LIST_COLUMN_IDS.RISK_ACCESS_RIGHTS]:
        withModeCodec(encodedArrayCodec),
};

export const controlEntitiesListRestoreConfig: TableRestoreConfig = {
    tableId: CONTROL_ENTITIES_TABLE_STATE_STORAGE_KEY,
    defaultValues: controlEntitiesListTableDefaultValues,
    codecMap: controlEntitiesListColumnFiltersCodecMap,
    onError: Sentry.captureException,
};
